import { render } from "./LectureViewReport.vue?vue&type=template&id=785d91f2&scoped=true"
import script from "./LectureViewReport.vue?vue&type=script&lang=js"
export * from "./LectureViewReport.vue?vue&type=script&lang=js"

import "./LectureViewReport.vue?vue&type=style&index=0&id=785d91f2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785d91f2"]])

export default __exports__